module.exports = __webpack_public_path__ + "img/in-ka.c5e69ac3.svg";